import { openDB } from 'idb'

const scriptTrimMessages = `/* Hides text from a message
~~~~
like here
~~~~
*/
request.messages = request.messages.map(m => {
    const newContent = m.content.map(c => {
        if (c.type !== 'text') return c;
        const newText = c.text.split(/^~~~~$/gm)
            .filter((_, index) => index % 2 === 0)
            .join('');
        return { ...c, text: newText };
    });
    return { ...m, content: newContent };
});
`

const scriptPrompts = `/* Prompts. Start a message with:
- %%R for short answers
*/
const PROMPTS = {
    R: \`You are a helpful assistant. Your responses have no babbling! No code explanations unless asked.\\n\\n\`,
};

request.messages = request.messages.map(m => {
    const newContent = m.content.map(c => {
        if (c.type !== 'text') return c;
        const newText = c.text.replace(/%%(\\w+)/g, (match, p1) => PROMPTS[p1] || match);
        return { ...c, text: newText };
    });
    return { ...m, content: newContent };
});
`


async function initDb() {
  if (navigator.storage && navigator.storage.persist) {
    navigator.storage.persist().then((persistent) => {})
  }

  try {
    return await openDB('eimi', 5, {
      upgrade: async function upgrade(db, oldVersion, newVersion, transaction, event) {
        console.log('db upgrade', db, oldVersion, newVersion, transaction, event)
        if (oldVersion < 1) {
          db.createObjectStore('sessions')
        }
        if (oldVersion < 2) {
          db.createObjectStore('scripts', { keyPath: 'id' })
        }
        if (oldVersion < 3) {
          const sessionMetaStore = db.createObjectStore('sessionMeta', { keyPath: 'id' })
          const sessionStore = transaction.objectStore('sessions')
          const sessionKeys = await sessionStore.getAllKeys()
          sessionKeys.sort((a, b) => b.localeCompare(a))
          for (const key of sessionKeys) {
            const session = await sessionStore.get(key)
            await sessionMetaStore.put({
              id: key,
              title: session.title,
              createdAt: session.createdAt,
            })
          }
        }
        if (oldVersion < 4) {
          const scriptStore = transaction.objectStore('scripts')
          const scripts = await scriptStore.getAll()
          for (const script of scripts) {
            script.scriptChainProcess = `throw new Error('Update to request arg');\n${script.scriptChainProcess}`
            await scriptStore.put(script)
          }
        }
        if (oldVersion < 5) {
          const scriptStore = transaction.objectStore('scripts')
          await scriptStore.put({
            id: "lzflks6m",
            enabled: true,
            name: "01 Trim Messages",
            sessionId: "",
            scriptChainProcess: scriptTrimMessages,
          })
          await scriptStore.put({
            id: "lziy5kpb",
            enabled: true,
            name: "02 Prompts",
            sessionId: "",
            scriptChainProcess: scriptPrompts,
          })
        }
        await transaction.done
      },
      blocked(currentVersion, blockedVersion, event) {
        alert('please close other tabs to upgrade db')
      },
      blocking(currentVersion, blockedVersion, event) {
      },
      terminated() {
        alert('idb terminated')
      },
    })
  } catch (e) {
    alert('Could not create IndexedDB, try in non-private tab')
  }

  return null
}

export const db = initDb()
window._db = db

export async function rebuildSessionMeta() {
  const tx = (await db).transaction(['sessions', 'sessionMeta'], 'readwrite')
  const sessionStore = tx.objectStore('sessions')
  const sessionMetaStore = tx.objectStore('sessionMeta')

  await sessionMetaStore.clear()

  const sessionKeys = await sessionStore.getAllKeys()
  for (const key of sessionKeys) {
    const session = await sessionStore.get(key)
    await sessionMetaStore.put({
      id: key,
      title: session.title,
      createdAt: session.createdAt,
    })
  }
  await tx.done
}
window._rebuildSessionMeta = rebuildSessionMeta
